import { render } from "./organizationHotels.vue?vue&type=template&id=74c7ab26"
import script from "./organizationHotels.vue?vue&type=script&lang=js"
export * from "./organizationHotels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__